import { Component, OnInit, ViewChild } from '@angular/core';
import { GridColumnDef, GridComponent } from '@williams-ui-platform/w-ui-angular';
import { Subject, takeUntil } from 'rxjs';
import {ContactsInterface, ContactsList, DepartmentContact} from '../store/model/contacts.interface';
import { ContactsService } from '../store/services/contacts.service';
import { transformContactData } from '../utils/contact.tranform';
import { DISCOVERY_GAS_TRANSMISSION,DISCOVERY_CONTACT_LIST, DISCOVERY_GAS_ADDRESS, DISCOVERY_GAS_ADDRESS1, EXPORT_TO_CSV } from '../constant';
import { environment} from "../../environments/environment";
type ExtendedDepartmentContact = DepartmentContact & { [key: string]: string };

@Component({
  selector: 'williams-ui-platform-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit {
  csvIcon= 'assets/w-ui-angular/images/csv.svg';
  hoveredCsvIcon = 'assets/w-ui-angular/images/csv.svg';
  activedCsvIcon ='assets/w-ui-angular/images/csv-white.svg';
  nameOfPage:string = `${environment.ShortName} Pipeline Contacts`;
  gasTitle = `${environment.EBBName}`;
  discoveryAddress = environment.longAddress1;
  discoveryAddress1 = environment.longAddress2;
  downloadCsv = EXPORT_TO_CSV;
  contacts = 'assets/w-ui-angular/images/DauphinContacts.htm';
  gridData: ContactsList[] = [];
  contactData!: ContactsInterface;
  destroy$: Subject<boolean> = new Subject<boolean>();
  gridColumnDef: GridColumnDef[] = [
    {
      field: 'department',
      title: 'Group',
      editable: false,
      columnMenu: false
    },
    {
      field: 'name',
      title: 'Name',
      editable: false,
      columnMenu: false
    },
    {
      field: 'role',
      title: 'Title',
      editable: false,
      columnMenu: false
    },
    {
      field: "officePhone",
      title: "Office Phone",
      editable: false,
      columnMenu: false
    },
    {
      field: "contactNumber",
      title: "Cell Phone",
      editable: false,
      columnMenu: false
    },
    {
      field: "emailId",
      title: "Email",
      editable: false,
      columnMenu: false,
      isHyperlink: true
    },
    {
      field: "fax",
      title: "Fax",
      editable: false,
      columnMenu: false
    },
  ]
  @ViewChild('contactsData') gridComponentRef!: GridComponent;

  constructor(private contactsService: ContactsService) {
  }

  ngOnInit(): void {
    if (environment.showContacts === 'true') {
      this.fetchContactsData();
    } else {
      this.fetchGridData();
    }
  }

  fetchGridData() {
    this.contactsService.getDocumentData(environment.fileLocation,'Contacts.csv')
        .pipe(takeUntil(this.destroy$))
        .subscribe((res: string) => {
          const contacts = this.parseContactsDataFromCsv(res);
          const departmentMainContact = this.extractDepartmentMainContact(contacts);
          this.gridData = contacts;
          this.contactData = { departmentContacts: contacts, departmentMainContact};
        });
  }

  parseContactsDataFromCsv(data: string): ContactsList[] {
    const contacts: ContactsList[] = [];
    const rows = data.split('\n');
    for (let i = 1; i < rows.length; i++) {
      const cells = rows[i].split(',');
      if (cells.length > 1) {
        const contact: ContactsList = {
          contactType: '',
          contactId: 0,
          department: cells[0].trim(),
          name: cells[1].trim(),
          role: cells[2].trim(),
          officePhone: cells[3].trim(),
          contactNumber: cells[4].trim(),
          emailId: cells[5].trim(),
          fax: cells[6].trim(),
          iceHandle: null,
          roles: [],
          regions: {}
        };
        contacts.push(contact);
      }
    }
    return contacts;
  }

  extractDepartmentMainContact(contacts: ContactsList[]): ExtendedDepartmentContact {
    const departmentMainContact: ExtendedDepartmentContact = {
      "Volume Management": "",
      "Pipeline Control": "9185737400" // Hardcoded number
    };

    return departmentMainContact;
  }

  fetchContactsData() {
    this.contactsService.getContactsData()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: ContactsInterface) => {
        this.contactData = res;
        this.gridData = res.departmentContacts.map(transformContactData);
      })
  }

  onHyperlinkClick(event: any) {
    const mailText = "mailto:" + event.dataItem.emailId;
    window.location.href = mailText;
  }

  linkColor(item: object, field: string) {
    return { 'link-color': (field === 'emailId') };
  }

  export(){
    this.gridComponentRef.saveAsCSV();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
